import { useEffect, useState, useRef } from "react"
import FilesModule from "../../../Modules/FilesModule"
import VariableModule from "../../../Modules/VariableModule"

import { SettingsGroup } from "../../../Modules/General"
import * as Basic from "../../../Modules/BasicFields"

const tugOfWarVariables = [
    {name:'Control',key:'control',type:'R'},
    {name:'Cooldown',key:'cooldown',type:'W'}
]

const filesList = [
    {name:'Marker image', key:'marker'},
    {name:'Goal image', key:'goal_image'}
]

export default function TugOfWarProperties( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const reset = props.reset

    const [ leftHashtag, setLeftHashtag ] = useState(null)
    const [ rightHashtag, setRightHashtag ] = useState(null)
    const [ numSteps, setNumSteps ] = useState(null)
    const [ cooldown, setCooldown ] = useState(null)
    const [ markerOverride, setMarkerOverride ] = useState(null)
    const [ barColor, setBarColor ] = useState(null)
    const [ markerColor, setMarkerColor ] = useState(null)
    const [ variables, setVariables ] = useState(null)
    const [ files, setFiles ] = useState(null)

    const requiredData = [
        leftHashtag,
        rightHashtag,
        numSteps,
        cooldown,
        markerOverride,
        barColor,
        markerColor,
        variables,
        files
    ]

    const cfgName = 'influencer_tug_of_war_cfg'

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setLeftHashtag(cfg.left_hashtag || "")
        setRightHashtag(cfg.right_hashtag || "" )
        setNumSteps((cfg.num_steps != null) ? cfg.num_steps : 1)
        setCooldown((cfg.cooldown != null) ? cfg.cooldown : 0)
        setMarkerOverride( cfg.marker_override || "none" )
        setBarColor(cfg.bar_color || { r: 255, g: 0, b: 0, a: 1.0 })
        setMarkerColor(cfg.marker_color || { r: 255, g: 0, b: 0, a: 1.0 })
        setVariables(cfg.variables || {} )
        setFiles(cfg.files || {} )
    }

    useEffect(() => {
        reload()
    },[])

    useEffect(() => {
        if( requiredData.includes(null) )
        {
            return
        }
       
        let data = {}
        data.left_hashtag = leftHashtag
        data.right_hashtag = rightHashtag
        data.num_steps = numSteps
        data.cooldown = cooldown
        data.marker_override = markerOverride
        data.bar_color = barColor 
        data.marker_color = markerColor
        data.variables = variables
        data.files = files

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)

    },[ leftHashtag, rightHashtag, numSteps, cooldown, markerOverride, barColor, markerColor, variables, files ])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
            <SettingsGroup name="Behaviour">
                <Basic.StringInput name="Move left hashtag" value={leftHashtag} setValue={setLeftHashtag}/>
                <Basic.StringInput name="Move right hashtag" value={rightHashtag} setValue={setRightHashtag}/>
                <Basic.PositiveIntegerInput name="Number of steps" value={numSteps} setValue={setNumSteps}/>
                <Basic.PositiveIntegerInput name="Cooldown" value={cooldown} setValue={setCooldown}/>
                <Basic.SelectInput name="Marker override" value={markerOverride} setValue={setMarkerOverride}
                                   options={[
                                { label: "None", value: "none" },
                                { label: "Avatar", value: "avatar" },
                            ]}
                />
            </SettingsGroup>
            <SettingsGroup name="Appearance">
                <Basic.ColorInput name="Bar color" value={barColor} setValue={setBarColor}/>
                <Basic.ColorInput name="marker Color" value={markerColor} setValue={setMarkerColor} />
            </SettingsGroup>
            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={tugOfWarVariables} 
                            reset={reset}
            />
            <FilesModule files={files} 
                         setFiles={setFiles}
                         filesList={filesList}
                         reset={reset}
            />
        </>
    )

}
